import { FormFieldControlled } from "@src/components/form-field"
import InputPhoneNumber from "@src/components/input-phone-number"
const FormFieldInputPhoneNumber = FormFieldControlled(InputPhoneNumber)
export default FormFieldInputPhoneNumber
